import {Header} from "@/components/Header";
import React from "react";
import {t} from "i18next";
import {useNavigate} from "react-router-dom";

export const Ambajogai = () => {
	const navigate = useNavigate();

	return (
		<>
			<div className="w-full flex flex-col items-center justify-center">
				<Header/>

				<img
					src="/other_imgs/banner-dharmik-inside.jpg"
					alt="Information Banner"
					className="w-full h-[30vh] object-cover shadow-lg"
				/>

				<div className="h-[70vh] flex flex-col">
					<h1 className="text-center font-custom-bold text-3xl my-[4vh] text-red-800">
						{t("RELIGIOUS_PAGE.YOGESHWARI_DEVI.PAGE_TITLE")}
					</h1>

					<div
						className="sm:flex sm:flex-row flex flex-col-reverse sm:h-[50vh]
                            justify-between p-[2vh] pt-0 gap-y-[2vh] gap-x-[2rem]"
					>
						{/* Left Section - Image */}
						<div className="h-auto w-full flex gap-[2rem]">
							{/*<div className="h-full aspect-square flex-1 flex items-center justify-center">*/}

							{/*</div>*/}
							<p className="leading-snug text-justify font-custom-medium text-[1.25rem]">
								<img
									src="/other_imgs/thumbnail-dharmik-ambajogai.png"
									alt="Vyadeshwar Mandir Idol"
									className="sm:max-h-[25rem] aspect-square object-cover
                                    sm:mr-[2rem] float-left shadow-md rounded-lg"
								/>
								{t("RELIGIOUS_PAGE.YOGESHWARI_DEVI.DESCRIPTION")}
							</p>
						</div>

						{/* Right Section - Buttons */}

						<div
							className="portrait:w-full landscape:w-1/3 h-auto flex flex-col items-center justify-between gap-y-[1rem]">
							{/* Live Darshan */}
							<button
								className="w-full flex-1 min-h-[8vh] max-h-[8vh]
                                flex items-center justify-center gap-x-[2vh]
                                bg-red-600 hover:bg-red-700
                                px-6 py-2 rounded-xl shadow
                                text-white font-custom-bold text-[2.5vh]"

							>
								<img
									alt={"Live Darshan"}
									src="/other_imgs/icon-live-recording-dot.png"
									className="h-[80%] aspect-square"
								/>
								<p className={"font-bold text-[2.5vh] text-white"}>
									{t("RELIGIOUS_PAGE.YOGESHWARI_DEVI.LIVE_DARSHAN.BUTTON_TITLE")}
								</p>
							</button>

							{/* Temple Time Table */}
							<button
								className="w-full min-h-[8vh] max-h-[8vh]
                                flex items-center justify-center gap-x-[2vh]
                                bg-red-600 hover:bg-red-700
                                px-6 py-2 rounded-xl shadow
                                text-white font-custom-bold text-[2.5vh]"
							>
								<img
									alt={"Temple Time Table"}
									src="/other_imgs/icon-temple-timetable.png"
									className="h-[80%] aspect-square"
								/>
								<p className={"font-bold text-[2.5vh] text-white"}>
									{t("RELIGIOUS_PAGE.YOGESHWARI_DEVI.MANDIR_TIMETABLE.BUTTON_TITLE")}
								</p>
							</button>

							{/* Book Puja */}
							<button
								className="w-full min-h-[8vh] max-h-[8vh]
                                flex items-center justify-center gap-x-[2vh]
                                bg-red-600 hover:bg-red-700
                                px-6 py-2 rounded-xl shadow
                                text-white font-custom-bold text-[2.5vh]"
							>
								<p className={"font-bold text-[2.5vh] text-white"}>
									{t("RELIGIOUS_PAGE.YOGESHWARI_DEVI.BOOK_PUJA.BUTTON_TITLE")}
								</p>
							</button>

							{/* Aarti */}
							<button
								onClick={() => navigate("/yogeshwari_aarti")}
								className="bg-gradient-to-tr from-orange-400 via-orange-500 to-orange-700
                    px-6 py-2 rounded-xl shadow
                    flex items-center justify-center gap-x-[2vh]
                    w-full flex-1 min-h-[8vh] max-h-[8vh]"
							>
								<img
									alt={"Aarti"}
									src="/other_imgs/thumbnail-aarti.jpg"
									className="h-[80%] aspect-square rounded-lg"
								/>
								<p className={"font-bold text-[2.5vh] text-white"}>
									{t("RELIGIOUS_PAGE.AARTI")}
								</p>
							</button>

							{/* Mantropchar */}
							<button
								onClick={() => navigate("/yogeshwari-devi-mantropchar")}
								className="bg-gradient-to-tr from-orange-400 via-orange-500 to-orange-700
                                    px-6 py-2 rounded-xl shadow
                                    flex items-center justify-center gap-x-[2vh]
                                    w-full flex-1 min-h-[8vh] max-h-[8vh]"
							>
								<img
									alt={"Mantrochar"}
									src="/other_imgs/thumbnail-mantropchar.jpg"
									className="h-[80%] aspect-square rounded-lg"
								/>
								<p className={"font-bold text-[2.5vh] text-white"}>
									{t("RELIGIOUS_PAGE.MANTROPCHAR")}
								</p>
							</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
